export default {
  store_namespace: 'productfamily',
  new_route_name: "ProductFamilyNew",
  edit_route_name: "ProductFamilyEdit",
  auth_feature: 'productfamily',
  detail_route_name: "ProductFamilyDetail",
  csv_export_filename_prefix: 'productfamily',
  hide_action_new_button: false,
  hide_action_pdf_button: true,
  hide_action_edit_button: false,
  hide_action_delete_button: true,
  export_csv: false,
  export_pdf: false,
  duplications: true,
  title_field: 'code',
  sort_by: 'code',
  sort_desc: false,
  fields: [
    {
      name: 'code',
      label: "Code",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      sortable: true,
    },
    {
      name: 'name',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      filterIn: true,
      inDetail: true,
      sortable: true,
      inCsvExport: true,
      inPdfExport: true,
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/ProductFamily/config.js